<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Job Grid Lists" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-xxl-4 col-sm-12">
                        <div class="search-box">
                            <input type="text" class="form-control search bg-light border-light" id="searchJob" autocomplete="off" placeholder="Search for jobs or companies..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()"> 
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xxl-3 col-sm-4">
                        <input type="text" class="form-control bg-light border-light" id="datepicker" placeholder="Select date" mwlFlatpickr [altInput]="true" [(ngModel)]="date" [convertModelValue]="true" [dateFormat]="'d M, Y'" mode="range">
                    </div>
                    <!--end col-->
                    <div class="col-xxl-2 col-sm-4">
                        <div class="input-light">
                            <select class="form-control" data-choices data-choices-search-false name="choices-idType" id="idType">
                                <option value="all" selected>All</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Internship">Internship</option>
                                <option value="Freelance">Freelance</option>
                            </select>
                        </div>
                    </div>
                    <!--end col-->

                    <div class="col-xxl-2 col-sm-4">
                        <div class="input-light">
                            <select class="form-control" data-choices data-choices-search-false name="choices-single-default" id="idStatus">
                                <option value="all" selected>All</option>
                                <option value="Active">Active</option>
                                <option value="New">New</option>
                                <option value="Close">Close</option>
                            </select>
                        </div>
                    </div>
                    <!--end col-->

                    <div class="col-xxl-1 col-sm-4">
                        <button type="button" class="btn btn-primary w-100" onclick="filterData();">
                            <i class="ri-equalizer-fill mx-1 align-bottom"></i> Filters
                        </button>
                    </div>
                    <!--end col-->
                </div>
                <!--end row-->
            </div>
        </div>
    </div>
</div>
<!-- end row -->

<div class="row">
    <div class="col-lg-12">
        <div class="d-flex align-items-center mb-4">
            <div class="flex-grow-1">
                <p class="text-muted fs-14 mb-0">Result: <span id="total-result">{{alljobgrids?.length}}</span></p>
            </div>
            <div class="flex-shrink-0">
                <div ngbDropdown class="dropdown">
                    <a ngbDropdownToggle class="text-muted fs-14 dropdown-toggle" href="javascript:void(0)" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                        All View
                    </a>
                    <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <li><a class="dropdown-item" href="javascript:void(0)">Action</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0)">Another action</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0)">Something else here</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end row -->
<div class="row" id="job-list">
    @for (grid of jobgrids; track $index) {
    <div class="col-lg-3 col-md-6">
        @if(grid.id == '0'){
        <div>
            <div class="card card-height-100 bg-info bg-job">
                <div class="card-body p-5">
                    <h2 class="lh-base text-white">Velzon invites young professionals for an Internship!</h2>
                    <p class="text-white text-opacity-75 mb-0 fs-14">Don't miss your opportunity to improve your skills!</p>
                    <div class="mt-5 pt-2"> <button type="button" class="btn btn-light w-100">View More <i class="ri-arrow-right-line align-bottom"></i></button> </div>
                </div>
            </div>
        </div>
        }
        @if(grid.id > '0'){
        <div class="card">
            <div class="card-body"> <button type="button" class="btn btn-icon btn-soft-primary float-end" data-bs-toggle="button" aria-pressed="true"><i class="mdi mdi-cards-heart fs-16"></i></button>
                <div class="avatar-sm mb-4">
                    <div class="avatar-title bg-light rounded"> <img src="{{grid.logo}}" alt="" class="avatar-xxs">
                    </div>
                </div> <a href="javascript:void(0);">
                    <h5>{{grid.title}}</h5>
                </a>
                <p class="text-muted">{{grid.companyname}}</p>
                <div class="d-flex gap-4 mb-3">
                    <div><i class="ri-map-pin-2-line text-primary me-1 align-bottom"></i> {{grid.location}}</div>
                    <div><i class="ri-time-line text-primary me-1 align-bottom"></i> {{grid.date}}</div>
                </div>
                <p class="text-muted">{{grid.content}}</p>
                <div class="hstack gap-2">
                    @for (type of grid.type; track $index) {
                    <span class="badge" [ngClass]="{ 'bg-success-subtle text-success': type === 'Full Time', 'bg-primary-subtle text-primary': type === 'Freelance', 'bg-danger-subtle text-danger': type === 'Urgent', 'bg-warning-subtle text-warning': type === 'Part Time', 'bg-info-subtle text-info': type === 'Private'}">{{type}}</span>
                    }
                </div>
                <div class="mt-4 hstack gap-2"> <a href="javascript:void(0);" class="btn btn-soft-primary w-100">Apply
                        Job</a> <a routerLink="/overview" class="btn btn-soft-success w-100">Overview</a> </div>
            </div>
        </div>
        }
    </div>
    }
    <!-- pagination -->
    <ngb-pagination class="d-flex justify-content-end pt-2" [collectionSize]="alljobgrids?.length" [(page)]="service.page" [pageSize]="service.pageSize" aria-label="Custom pagination" (pageChange)="changePage()">
        <ng-template ngbPaginationPrevious let-page let-pages="pages">
            <i class="ci-arrow-left me-2"></i>
            Prev
        </ng-template>
        <ng-template ngbPaginationNext>
            Next
            <i class="ci-arrow-right ms-2"></i>
        </ng-template>
    </ngb-pagination>

    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>